import useAppState from '../../state/appState';

export const DeleteFormValues = () => {
    const resetFormValues = useAppState((state) => state.resetFormValues);

    resetFormValues();

    return (
        <>
            <div>formValues have been cleared - Waiting for the automatic redirect</div>
        </>
    );
};
